module.exports = __webpack_public_path__ + "img/user-solid.88336417.svg";